import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
  makeStyles,
  TextareaAutosize,
  MenuItem,
  Select,
  Checkbox,
} from "@material-ui/core";

import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";

//--- SunEditor
import SunEditor, { buttonList } from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

import * as config from "../../../common/config";
import * as notificationTemplateAction from "../../../redux/store/notification/notification.store";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../utils/configuration";
import * as viVN from "../../../language/vi-VN.json";

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  formControl: {
    margin: theme.spacing(1),
  },
}));

function AddNotification(props) {
  const classes = useStyles();
  const {
    openAddDialog,
    onHideModal,
    getListNotificationModels,
    rowsPerPageCommon,
    setOrderBy,
    setOrder,
  } = props;
  const {
    register,
    handleSubmit,
    errors,
    setError,
    clearErrors,
    setValue,
  } = useForm({ mode: "all", reValidateMode: "onBlur" });

  const [active, setActive] = useState(false);
  const [type, setType] = useState("");

  const onAddSubmit = (data) => {

    const notificationModel = {
      ...data,
      isActive: active,
      type: type
    }
    notificationTemplateAction.CreateNotification(notificationModel).then(
      (res) => {
        if (res && res.content) {
          getListNotificationModels(1, rowsPerPageCommon, "", "", "", "", "");
          onHideModal();
          ShowNotification(
            viVN.Success.CreateSuccess,
            NotificationMessageType.Success
          );
        }
      },
      (err) => {
        err &&
          err.errorType &&
          ShowNotification(
            viVN.Errors[err.errorType],
            NotificationMessageType.Error
          );
      }
    );
  };

  return (
    <div>
      <Dialog
        open={openAddDialog}
        onClose={onHideModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title" className="border-bottom">
          {"Thêm mới"}
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onHideModal}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <form onSubmit={handleSubmit(onAddSubmit)}>
          <DialogContent className="pt-4 pb-2">
            <div className="form-group">
              <div className="row">
                <div className="col-12 col-md-12 col-lg-12">
                  <label className="text-dark">
                    Nội dung<span className="required"></span>
                  </label>
                  <TextareaAutosize
                    name='content'
                    rowsMin={3}
                    className={'form-control'}
                    ref={register({ required: true })}
                    onChange={(e) =>
                      setValue("type", e.target.value, "")
                    }
                  />
                  {errors.content && errors.content.type === "required" && (
                    <span className="error">Trường này là bắt buộc</span>
                  )}
                </div>
              </div>
            </div>

            <div className="form-group">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-6">
                  <label className="text-dark">Loại</label>
                  <Select
                    name="type"
                    variant="outlined"
                    value={type}
                    className="w-100"
                    size="small"
                    onChange={(e) =>
                      setType(e.target.value)
                    }
                  >
                    <MenuItem value=""></MenuItem>
                    <MenuItem value="PLANNING">Quy hoạch </MenuItem>
                    <MenuItem value="PROJECT">Dự án</MenuItem>
                    <MenuItem value="CLASSIFIED">Giá đất</MenuItem>
                  </Select>
                </div>
                <div className="col-12 col-md-6 col-lg-6">
                  <label className="text-dark">
                    Resource Id
                  </label>
                  <TextField
                    name="resourceId"
                    type="text"
                    fullWidth
                    size="small"
                    variant="outlined"
                    onChange={(e) =>
                      setValue("resourceId", e.target.value.replace(/[^0-9]/g, ""))
                    }
                  />

                </div>

              </div>
            </div>
            <div className='form-group'>
              <div className='row'>
                <div className='col-12 col-md-4 col-lg-4'>
                  <label className='text-dark'>Kích hoạt</label>
                  <Checkbox
                    checked={active}
                    onChange={(e) => setActive(e.target.checked)}
                    color='primary'
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                    className='p-0 mt-0 ml-4'
                  />
                </div>
              </div>
            </div>
          </DialogContent>
          <DialogActions className="border-top">
            <Button
              onClick={onHideModal}
              variant="contained"
              startIcon={<CloseIcon />}
            >
              Hủy
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              startIcon={<SaveIcon />}
            >
              {config.NotificationConfig.save}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}
export default AddNotification;
